import user1 from '../assets/2.jpg';
import user2 from '../assets/128x128.jpg';
import user3 from '../assets/3.jpg';
import user4 from '../assets/1.jpg';

const challengeUsers = [
    {
        name: '1-10',
        items :[
            {
                pos: '1',
                photo: user1,
                name: 'Alice',
                rank: '27',
                wins: '24',
                losses: '37',
                gameMerits: '37',
                totalMerits: '37'
            },
            {
                pos: '2',
                photo: user2,
                name: 'John',
                rank: '77',
                wins: '37',
                losses: '26',
                gameMerits: '34',
                totalMerits: '19'
            },
            {
                pos: '3',
                photo: user1,
                name: 'Najya',
                rank: '19',
                wins: '14',
                losses: '16',
                gameMerits: '36',
                totalMerits: '33'
            },
            {
                pos: '4',
                photo: user2,
                name: 'Khaib',
                rank: '71',
                wins: '17',
                losses: '16',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '5',
                photo: user2,
                name: 'Brooke',
                rank: '42',
                wins: '11',
                losses: '15',
                gameMerits: '36',
                totalMerits: '19'
            },
            {
                pos: '6',
                photo: user1,
                name: 'Tahlia',
                rank: '71',
                wins: '16',
                losses: '19',
                gameMerits: '29',
                totalMerits: '29'
            },
            {
                pos: '7',
                photo: user2,
                name: 'Adam',
                rank: '15',
                wins: '29',
                losses: '30',
                gameMerits: '14',
                totalMerits: '34'
            },
            {
                pos: '8',
                photo: user1,
                name: 'Merci',
                rank: '19',
                wins: '18',
                losses: '36',
                gameMerits: '28',
                totalMerits: '31'
            },
            {
                pos: '9',
                photo: user3,
                name: 'Ghusoon',
                rank: '89',
                wins: '18',
                losses: '24',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '10',
                photo: user4,
                name: 'Robert',
                rank: '84',
                wins: '40',
                losses: '18',
                gameMerits: '20',
                totalMerits: '35'
            }
        ]},
    {
        name: '11-20',
        items :[

            {
                pos: '11',
                photo: user4,
                name: 'Isabella',
                rank: '26',
                wins: '33',
                losses: '34',
                gameMerits: '23',
                totalMerits: '29'
            },
            {
                pos: '12',
                photo: user3,
                name: 'Arienne',
                rank: '51',
                wins: '12',
                losses: '22',
                gameMerits: '21',
                totalMerits: '19'
            },
            {
                pos: '13',
                photo: user4,
                name: 'Carlos',
                rank: '26',
                wins: '36',
                losses: '27',
                gameMerits: '36',
                totalMerits: '10'
            },
            {
                pos: '14',
                photo: user4,
                name: 'Nicolette',
                rank: '74',
                wins: '26',
                losses: '22',
                gameMerits: '21',
                totalMerits: '24'
            },
            {
                pos: '15',
                photo: user1,
                name: 'Zara',
                rank: '62',
                wins: '22',
                losses: '40',
                gameMerits: '25',
                totalMerits: '39'
            },
            {
                pos: '16',
                photo: user2,
                name: 'Al',
                rank: '41',
                wins: '35',
                losses: '15',
                gameMerits: '16',
                totalMerits: '12'
            },
            {
                pos: '17',
                photo: user1,
                name: 'Zara',
                rank: '31',
                wins: '18',
                losses: '14',
                gameMerits: '35',
                totalMerits: '23'
            },
            {
                pos: '18',
                photo: user3,
                name: 'Hugues',
                rank: '63',
                wins: '39',
                losses: '24',
                gameMerits: '29',
                totalMerits: '22'
            },
            {
                pos: '19',
                photo: user1,
                name: 'Angelina',
                rank: '18',
                wins: '33',
                losses: '24',
                gameMerits: '16',
                totalMerits: '22'
            },
            {
                pos: '20',
                photo: user2,
                name: 'Nancy',
                rank: '39',
                wins: '17',
                losses: '30',
                gameMerits: '26',
                totalMerits: '12'
            }
        ]
    },
    {
        name: '21-30',
        items :[
            {
                pos: '21',
                photo: user4,
                name: 'Abbey',
                rank: '51',
                wins: '35',
                losses: '19',
                gameMerits: '20',
                totalMerits: '30'
            },
            {
                pos: '22',
                photo: user2,
                name: 'Hugues',
                rank: '14',
                wins: '40',
                losses: '32',
                gameMerits: '28',
                totalMerits: '15'
            },
            {
                pos: '23',
                photo: user3,
                name: 'Molly',
                rank: '49',
                wins: '40',
                losses: '19',
                gameMerits: '32',
                totalMerits: '26'
            },
            {
                pos: '24',
                photo: user3,
                name: 'Fatima',
                rank: '44',
                wins: '25',
                losses: '21',
                gameMerits: '36',
                totalMerits: '18'
            },
            {
                pos: '25',
                photo: user1,
                name: 'Jade',
                rank: '30',
                wins: '35',
                losses: '15',
                gameMerits: '32',
                totalMerits: '10'
            },
            {
                pos: '26',
                photo: user4,
                name: 'Marilyn',
                rank: '84',
                wins: '12',
                losses: '19',
                gameMerits: '28',
                totalMerits: '14'
            },
            {
                pos: '27',
                photo: user1,
                name: 'Bianca',
                rank: '35',
                wins: '31',
                losses: '18',
                gameMerits: '27',
                totalMerits: '28'
            },
            {
                pos: '28',
                photo: user2,
                name: 'Holly',
                rank: '74',
                wins: '39',
                losses: '30',
                gameMerits: '30',
                totalMerits: '31'
            },
            {
                pos: '29',
                photo: user1,
                name: 'Hugues',
                rank: '51',
                wins: '31',
                losses: '40',
                gameMerits: '12',
                totalMerits: '32'
            },
            {
                pos: '30',
                photo: user1,
                name: 'Crystal',
                rank: '89',
                wins: '22',
                losses: '20',
                gameMerits: '22',
                totalMerits: '18'
            }]
    },
    {
        name: '31-40',
        items :[
            {
                pos: '31',
                photo: user2,
                name: 'Usamah',
                rank: '61',
                wins: '32',
                losses: '27',
                gameMerits: '25',
                totalMerits: '16'
            },
            {
                pos: '32',
                photo: user2,
                name: 'Shareef',
                rank: '31',
                wins: '17',
                losses: '11',
                gameMerits: '24',
                totalMerits: '15'
            },
            {
                pos: '33',
                photo: user2,
                name: 'Alice',
                rank: '59',
                wins: '28',
                losses: '33',
                gameMerits: '17',
                totalMerits: '18'
            },
            {
                pos: '34',
                photo: user2,
                name: 'Michael',
                rank: '58',
                wins: '10',
                losses: '23',
                gameMerits: '19',
                totalMerits: '38'
            },
            {
                pos: '35',
                photo: user1,
                name: 'Molly',
                rank: '77',
                wins: '19',
                losses: '30',
                gameMerits: '10',
                totalMerits: '26'
            },{
                pos: '36',
                photo: user1,
                name: 'Alice',
                rank: '27',
                wins: '24',
                losses: '37',
                gameMerits: '37',
                totalMerits: '37'
            },
            {
                pos: '37',
                photo: user3,
                name: 'John',
                rank: '77',
                wins: '37',
                losses: '26',
                gameMerits: '34',
                totalMerits: '19'
            },
            {
                pos: '38',
                photo: user1,
                name: 'Najya',
                rank: '19',
                wins: '14',
                losses: '16',
                gameMerits: '36',
                totalMerits: '33'
            },
            {
                pos: '39',
                photo: user2,
                name: 'Khaib',
                rank: '71',
                wins: '17',
                losses: '16',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '40',
                photo: user2,
                name: 'Brooke',
                rank: '42',
                wins: '11',
                losses: '15',
                gameMerits: '36',
                totalMerits: '19'
            }]
    },
    {
        name: '41-50',
        items :[
            {
                pos: '41',
                photo: user1,
                name: 'Tahlia',
                rank: '71',
                wins: '16',
                losses: '19',
                gameMerits: '29',
                totalMerits: '29'
            },
            {
                pos: '42',
                photo: user2,
                name: 'Adam',
                rank: '15',
                wins: '29',
                losses: '30',
                gameMerits: '14',
                totalMerits: '34'
            },
            {
                pos: '43',
                photo: user1,
                name: 'Merci',
                rank: '19',
                wins: '18',
                losses: '36',
                gameMerits: '28',
                totalMerits: '31'
            },
            {
                pos: '44',
                photo: user2,
                name: 'Ghusoon',
                rank: '89',
                wins: '18',
                losses: '24',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '45',
                photo: user2,
                name: 'Robert',
                rank: '84',
                wins: '40',
                losses: '18',
                gameMerits: '20',
                totalMerits: '35'
            },
            {
                pos: '46',
                photo: user4,
                name: 'Isabella',
                rank: '26',
                wins: '33',
                losses: '34',
                gameMerits: '23',
                totalMerits: '29'
            },
            {
                pos: '47',
                photo: user3,
                name: 'Arienne',
                rank: '51',
                wins: '12',
                losses: '22',
                gameMerits: '21',
                totalMerits: '19'
            },
            {
                pos: '48',
                photo: user4,
                name: 'Carlos',
                rank: '26',
                wins: '36',
                losses: '27',
                gameMerits: '36',
                totalMerits: '10'
            },
            {
                pos: '49',
                photo: user4,
                name: 'Nicolette',
                rank: '74',
                wins: '26',
                losses: '22',
                gameMerits: '21',
                totalMerits: '24'
            },
            {
                pos: '50',
                photo: user1,
                name: 'Zara',
                rank: '62',
                wins: '22',
                losses: '40',
                gameMerits: '25',
                totalMerits: '39'
            }]},
    {
        name: '51-60',
        items :[
            {
                pos: '51',
                photo: user2,
                name: 'Al',
                rank: '41',
                wins: '35',
                losses: '15',
                gameMerits: '16',
                totalMerits: '12'
            },
            {
                pos: '52',
                photo: user1,
                name: 'Zara',
                rank: '31',
                wins: '18',
                losses: '14',
                gameMerits: '35',
                totalMerits: '23'
            },
            {
                pos: '53',
                photo: user3,
                name: 'Hugues',
                rank: '63',
                wins: '39',
                losses: '24',
                gameMerits: '29',
                totalMerits: '22'
            },
            {
                pos: '54',
                photo: user1,
                name: 'Angelina',
                rank: '18',
                wins: '33',
                losses: '24',
                gameMerits: '16',
                totalMerits: '22'
            },
            {
                pos: '55',
                photo: user2,
                name: 'Nancy',
                rank: '39',
                wins: '17',
                losses: '30',
                gameMerits: '26',
                totalMerits: '12'
            },
            {
                pos: '56',
                photo: user4,
                name: 'Abbey',
                rank: '51',
                wins: '35',
                losses: '19',
                gameMerits: '20',
                totalMerits: '30'
            },
            {
                pos: '57',
                photo: user2,
                name: 'Hugues',
                rank: '14',
                wins: '40',
                losses: '32',
                gameMerits: '28',
                totalMerits: '15'
            },
            {
                pos: '58',
                photo: user3,
                name: 'Molly',
                rank: '49',
                wins: '40',
                losses: '19',
                gameMerits: '32',
                totalMerits: '26'
            },
            {
                pos: '59',
                photo: user3,
                name: 'Fatima',
                rank: '44',
                wins: '25',
                losses: '21',
                gameMerits: '36',
                totalMerits: '18'
            },
            {
                pos: '60',
                photo: user1,
                name: 'Jade',
                rank: '30',
                wins: '35',
                losses: '15',
                gameMerits: '32',
                totalMerits: '10'
            }]},
    {
        name: '61-70',
        items :[
            {
                pos: '61',
                photo: user4,
                name: 'Marilyn',
                rank: '84',
                wins: '12',
                losses: '19',
                gameMerits: '28',
                totalMerits: '14'
            },
            {
                pos: '62',
                photo: user1,
                name: 'Bianca',
                rank: '35',
                wins: '31',
                losses: '18',
                gameMerits: '27',
                totalMerits: '28'
            },
            {
                pos: '63',
                photo: user2,
                name: 'Holly',
                rank: '74',
                wins: '39',
                losses: '30',
                gameMerits: '30',
                totalMerits: '31'
            },
            {
                pos: '64',
                photo: user1,
                name: 'Hugues',
                rank: '51',
                wins: '31',
                losses: '40',
                gameMerits: '12',
                totalMerits: '32'
            },
            {
                pos: '65',
                photo: user1,
                name: 'Crystal',
                rank: '89',
                wins: '22',
                losses: '20',
                gameMerits: '22',
                totalMerits: '18'
            },
            {
                pos: '66',
                photo: user2,
                name: 'Usamah',
                rank: '61',
                wins: '32',
                losses: '27',
                gameMerits: '25',
                totalMerits: '16'
            },
            {
                pos: '67',
                photo: user2,
                name: 'Shareef',
                rank: '31',
                wins: '17',
                losses: '11',
                gameMerits: '24',
                totalMerits: '15'
            },
            {
                pos: '68',
                photo: user2,
                name: 'Alice',
                rank: '59',
                wins: '28',
                losses: '33',
                gameMerits: '17',
                totalMerits: '18'
            },
            {
                pos: '69',
                photo: user4,
                name: 'Michael',
                rank: '58',
                wins: '10',
                losses: '23',
                gameMerits: '19',
                totalMerits: '38'
            },
            {
                pos: '70',
                photo: user1,
                name: 'Molly',
                rank: '77',
                wins: '19',
                losses: '30',
                gameMerits: '10',
                totalMerits: '26'
            }]},
    {
        name: '71-80',
        items :[
            {
                pos: '71',
                photo: user1,
                name: 'Alice',
                rank: '27',
                wins: '24',
                losses: '37',
                gameMerits: '37',
                totalMerits: '37'
            },
            {
                pos: '72',
                photo: user3,
                name: 'John',
                rank: '77',
                wins: '37',
                losses: '26',
                gameMerits: '34',
                totalMerits: '19'
            },
            {
                pos: '73',
                photo: user1,
                name: 'Najya',
                rank: '19',
                wins: '14',
                losses: '16',
                gameMerits: '36',
                totalMerits: '33'
            },
            {
                pos: '74',
                photo: user3,
                name: 'Khaib',
                rank: '71',
                wins: '17',
                losses: '16',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '75',
                photo: user2,
                name: 'Brooke',
                rank: '42',
                wins: '11',
                losses: '15',
                gameMerits: '36',
                totalMerits: '19'
            },
            {
                pos: '76',
                photo: user1,
                name: 'Tahlia',
                rank: '71',
                wins: '16',
                losses: '19',
                gameMerits: '29',
                totalMerits: '29'
            },
            {
                pos: '77',
                photo: user2,
                name: 'Adam',
                rank: '15',
                wins: '29',
                losses: '30',
                gameMerits: '14',
                totalMerits: '34'
            },
            {
                pos: '78',
                photo: user4,
                name: 'Merci',
                rank: '19',
                wins: '18',
                losses: '36',
                gameMerits: '28',
                totalMerits: '31'
            },
            {
                pos: '79',
                photo: user2,
                name: 'Ghusoon',
                rank: '89',
                wins: '18',
                losses: '24',
                gameMerits: '32',
                totalMerits: '30'
            },
            {
                pos: '80',
                photo: user2,
                name: 'Robert',
                rank: '84',
                wins: '40',
                losses: '18',
                gameMerits: '20',
                totalMerits: '35'
            }]},
    {
        name: '81-90',
        items :[
            {
                pos: '81',
                photo: user4,
                name: 'Isabella',
                rank: '26',
                wins: '33',
                losses: '34',
                gameMerits: '23',
                totalMerits: '29'
            },
            {
                pos: '82',
                photo: user3,
                name: 'Arienne',
                rank: '51',
                wins: '12',
                losses: '22',
                gameMerits: '21',
                totalMerits: '19'
            },
            {
                pos: '83',
                photo: user4,
                name: 'Carlos',
                rank: '26',
                wins: '36',
                losses: '27',
                gameMerits: '36',
                totalMerits: '10'
            },
            {
                pos: '84',
                photo: user4,
                name: 'Nicolette',
                rank: '74',
                wins: '26',
                losses: '22',
                gameMerits: '21',
                totalMerits: '24'
            },
            {
                pos: '85',
                photo: user1,
                name: 'Zara',
                rank: '62',
                wins: '22',
                losses: '40',
                gameMerits: '25',
                totalMerits: '39'
            },
            {
                pos: '86',
                photo: user2,
                name: 'Al',
                rank: '41',
                wins: '35',
                losses: '15',
                gameMerits: '16',
                totalMerits: '12'
            },
            {
                pos: '87',
                photo: user1,
                name: 'Zara',
                rank: '31',
                wins: '18',
                losses: '14',
                gameMerits: '35',
                totalMerits: '23'
            },
            {
                pos: '88',
                photo: user3,
                name: 'Hugues',
                rank: '63',
                wins: '39',
                losses: '24',
                gameMerits: '29',
                totalMerits: '22'
            },
            {
                pos: '89',
                photo: user1,
                name: 'Angelina',
                rank: '18',
                wins: '33',
                losses: '24',
                gameMerits: '16',
                totalMerits: '22'
            },
            {
                pos: '90',
                photo: user2,
                name: 'Nancy',
                rank: '39',
                wins: '17',
                losses: '30',
                gameMerits: '26',
                totalMerits: '12'
            }]},
    {
        name: '91-100',
        items :[
            {
                pos: '91',
                photo: user4,
                name: 'Abbey',
                rank: '51',
                wins: '35',
                losses: '19',
                gameMerits: '20',
                totalMerits: '30'
            },
            {
                pos: '92',
                photo: user2,
                name: 'Hugues',
                rank: '14',
                wins: '40',
                losses: '32',
                gameMerits: '28',
                totalMerits: '15'
            },
            {
                pos: '93',
                photo: user3,
                name: 'Molly',
                rank: '49',
                wins: '40',
                losses: '19',
                gameMerits: '32',
                totalMerits: '26'
            },
            {
                pos: '94',
                photo: user3,
                name: 'Fatima',
                rank: '44',
                wins: '25',
                losses: '21',
                gameMerits: '36',
                totalMerits: '18'
            },
            {
                pos: '95',
                photo: user1,
                name: 'Jade',
                rank: '30',
                wins: '35',
                losses: '15',
                gameMerits: '32',
                totalMerits: '10'
            },
            {
                pos: '96',
                photo: user4,
                name: 'Marilyn',
                rank: '84',
                wins: '12',
                losses: '19',
                gameMerits: '28',
                totalMerits: '14'
            },
            {
                pos: '97',
                photo: user1,
                name: 'Bianca',
                rank: '35',
                wins: '31',
                losses: '18',
                gameMerits: '27',
                totalMerits: '28'
            },
            {
                pos: '98',
                photo: user2,
                name: 'Holly',
                rank: '74',
                wins: '39',
                losses: '30',
                gameMerits: '30',
                totalMerits: '31'
            },
            {
                pos: '99',
                photo: user1,
                name: 'Hugues',
                rank: '51',
                wins: '31',
                losses: '40',
                gameMerits: '12',
                totalMerits: '32'
            }]
    }
];

export default challengeUsers;


// WEBPACK FOOTER //
// ./src/data/challenges.js